import React from 'react' 

export const ResultItem = ({item})=> {

    return (
        <li>
            <div>
                <img src={`/assets/images/faces/${item.image}.png`} alt={item.name} />
                <div>
                    <div className="title">{item.name}</div>
                    <p className="description">{item.bio}</p>
                </div>
            </div>

            <p className="type">{item.type}</p>
        </li>
    )
} 